import React from 'react';
import styles from './PricingTestimonials.module.scss';

const PricingTestimonials = () => {
  return (
    <div className={styles.testimonialSection}>
      <div className="container">
        <h3 className={styles.testimonialHeading}>Why choose Twine Pro</h3>
        <div className="row">
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img src="https://i.pravatar.cc/50?img=1" alt="Harrison C." />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "Twine Pro streamlined my workflow tremendously. I've been able
                to land more gigs and manage projects efficiently without
                juggling multiple tools."
              </p>
              <div className={styles.testimonialAuthor}>Harrison C.</div>
              <div className={styles.testimonialDate}>Nov 1, 2024</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img
                src="https://user-images.trustpilot.com/650dcaa41513be00127f3e0e/73x73.png"
                alt="Ash S."
              />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "I have already worked in three jobs found on Twine, as a
                freelance native Italian speaker and I found great
                professionalism in the team, from the first contact to the
                follow up. Punctual payments and always active help desk."
              </p>
              <div className={styles.testimonialAuthor}>Sarah Zambon</div>
              <div className={styles.testimonialDate}>Feb 11, 2025</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img
                src="https://user-images.trustpilot.com/67aaff3c1be9f2058094fa7f/73x73.png"
                alt="Jordan S."
              />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "I am a freelancer looking for work and Twine is a perfect
                company to help me finding interesting projects all over the
                world. If something goes wrong, they give me excellent support."
              </p>
              <div className={styles.testimonialAuthor}>Jordan S.</div>
              <div className={styles.testimonialDate}>Aug 27, 2024</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img
                src="https://user-images.trustpilot.com/67aa69b7bbb6eaeb3a34e061/73x73.png"
                alt="Dean P."
              />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "Great tools for freelancers. The paid subscription works
                better, but in my experience, it's worth it if you build a
                strong profile and consistently send pitches for the jobs Twine
                suggests. You won't get every job, but with time and effort, you
                can build a solid client base."
              </p>
              <div className={styles.testimonialAuthor}>Rafael Vieira</div>
              <div className={styles.testimonialDate}>Feb 10, 2025</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img
                src="https://thumbs.twinecdn.com/7863fb3eaa7759c0e409d75a43d44ca4/avatar/3edfc911-0b21-452f-8eae-7353ed2cc67b/140x140.jpg"
                alt="Thaymisan C."
              />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "I've really enjoyed using Twine and appreciate how intuitive
                and efficient the platform is. The team has done a fantastic job
                in creating a seamless experience for collaboration and
                engagement."
              </p>
              <div className={styles.testimonialAuthor}>Thaymisan C.</div>
              <div className={styles.testimonialDate}>Jan 12, 2025</div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className={styles.testimonialCard}>
              <img
                src="https://user-images.trustpilot.com/67499472b370c8764f574f29/73x73.png"
                alt="Elizabeth R."
              />
              <p className={styles.stars}>★★★★★</p>
              <p>
                "Recommended convenient and easy to utilise compared to all
                other platforms for freelancers with fast paying process and for
                clients who frequently offer jobs to freelancers."
              </p>
              <div className={styles.testimonialAuthor}>Elizabeth R.</div>
              <div className={styles.testimonialDate}>May 5, 2024</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingTestimonials;
